import { Line } from "rc-progress";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { enrollModal, showModal } from "../../redux/actions";
import * as image from "../../resources/images";
import { PATHS } from "../../utils";
import { getAlluserCourses, getSequnceSort } from "../../utils/helper";
import { dashBoardCourseGoal, getPlanCourseGoal, getUserPlan, submitPlanCourseGoal } from "../../redux/actions/APIs";
import { toast } from "react-toastify";
import Success from "../notifications/Success";
import DeletePlanActivities from "../learnerplan/DeletePlanActivities";
import GoalSubmitPopUp from "./GoalSubmitPopUp";
//  import GoalSubmitPopUp from "./GoalSubmitPopUp";
const PlanGoals = ({ myplanData, dashBoardPlanData, closeModal, childData }) => {
	const dispatch = useDispatch();
	const history = useHistory();
	const inputRef = useRef([]);
	const { loggedInUser, defaultChildData, planCourseGoalData, planGoalSubmitData, modalData } = useSelector(
		(state) => state.collections
	);

	const [courseIndex, setCourseIndex] = useState(0);
	const [selectedCourse, setSelectedCourse] = useState();
	const [inputData, setInputData] = useState([]);
	const [isAlert, setIsAlert] = useState();
  const [isRender, setIsRender] = useState(false);
  const [isCodeRender, setIsCodeRender] = useState(false); 
  const [checkBoxIds, setCheckBoxIds] = useState([]);
  
  const courseLength = myplanData ? getAlluserCourses(myplanData)?.length : dashBoardPlanData?.records?.length;

  useEffect(() => {
    let corIndex = myplanData?.courseIndex ? myplanData.courseIndex : dashBoardPlanData?.courseIndex ? dashBoardPlanData?.courseIndex : 0;
    setCourseIndex(corIndex);
  },[])

	useEffect(() => {
		dispatch(submitPlanCourseGoal());
		if (myplanData) {
      let courseIds = [];
			getAlluserCourses(myplanData)?.map((course, index) => {
				courseIds.push(course?.id);
			});
			// console.log("myplanData @@@: ", getAlluserCourses(myplanData), courseIds);
			let userId = loggedInUser?.role?.name === "PARENT" ? loggedInUser?.id : childData?.id;
			dispatch(getPlanCourseGoal(userId, childData?.id, courseIds));
		}
  }, []);
  
  useEffect(() => {
    if (dashBoardPlanData?.records?.length > 0) {
        let getCourseObj = getSequnceSort(dashBoardPlanData?.records)[courseIndex];
      	setSelectedCourse(getCourseObj);

    }
  },[dashBoardPlanData, courseIndex, isCodeRender])

	useEffect(() => {
		if (planCourseGoalData?.records?.length > 0 && myplanData) {
			let getCourseObj = getSequnceSort(planCourseGoalData?.records)[courseIndex];
			// let myPlanCourse = getAlluserCourses(myplanData)?.find((item) => item?.id === getCourseObj?.courseId);
			// getCourseObj.isDefinedGoal = myPlanCourse?.isDefinedGoal;
			// console.log("getCourseObj : ", getCourseObj, myPlanCourse);
			setSelectedCourse(getCourseObj);
		}
	}, [planCourseGoalData?.records, courseIndex, isCodeRender])

	const handleSelectedCourse = (corInd, isNext) => {
		if (isNext) {
			handleSubmitPlan();
		}
		if (corInd >= 0 && corInd < courseLength) {
			setCourseIndex(corInd);
			setInputData([]);
		}
	};
	const handleInput = (inputId) => {

		let goalIds = [...inputData]
		const key = inputData?.findIndex((goalId) => goalId === inputId);

		if (key === -1) {
			goalIds.push(inputId);
		} else {
			goalIds.splice(key, 1);
		}

		// console.log("handleInput : ",inputId,  goalIds, [...inputData], key);

		setInputData(goalIds);

	}

	const handleCheckBox = (goalObj) => {
		goalObj.isCompleted = !goalObj.isCompleted;
		console.log("handleCheckBox @@ : ", goalObj.isCompleted);
		setIsRender(!isRender);
		if(selectedCourse?.isDefinedGoal){
				let idsArr = [...checkBoxIds]
				const key = checkBoxIds?.findIndex((ckId) => ckId === goalObj?.id);

				if (key === -1) {
					idsArr.push(goalObj?.id);
				} else {
					idsArr.splice(key, 1);
				}
				setCheckBoxIds(idsArr);
		}

	}

	const handleInputChange = (goalObj, value) => {
		goalObj.keyName = value.trimStart();
		setIsRender(!isRender);
	}

	const handleSubmitPlan = () => {
		let userId = loggedInUser?.role?.name === "PARENT" ? loggedInUser?.id : childData?.id;
		let courseObj = { userId: userId, learnerId: childData?.id, courses: [selectedCourse] }
		dispatch(submitPlanCourseGoal(userId, [courseObj]));

	}

	const showAlertPopUp = () => {
		if (selectedCourse?.goal?.keyResults?.every((item)=>item?.keyName)) {
            setIsAlert(true);
			setInputData([]);
        }
	}

	const closePopUp = () => {
		setIsAlert(false);
	}

	useEffect(() => {
		if (planGoalSubmitData?.success) {
			let getCurentCourse = planGoalSubmitData?.records[0]?.courses[0];
			if(planCourseGoalData?.records?.length > 0){
				const corKey = planCourseGoalData?.records?.findIndex((item)=>item?.courseId === getCurentCourse?.courseId)
				if(corKey !== -1){
					planCourseGoalData.records[corKey] = getCurentCourse;
					setIsCodeRender(!isCodeRender);
				}
			}else if(dashBoardPlanData?.records?.length > 0){
					const corKey = dashBoardPlanData?.records?.findIndex((item)=>item?.courseId === getCurentCourse?.courseId)
					if(corKey !== -1){
						dashBoardPlanData.records[corKey] = getCurentCourse;
						setIsCodeRender(!isCodeRender);
					}
			}
			let userId = loggedInUser?.role?.name === "PARENT" ? loggedInUser?.id : childData?.id;
			if (myplanData) {
				dispatch(getUserPlan(userId, childData?.id))
			}
			if (dashBoardPlanData) {
				dispatch(dashBoardCourseGoal(userId, childData?.id, dashBoardPlanData?.planId));
			}
			dispatch(submitPlanCourseGoal());
			if (courseIndex + 1 === courseLength) {
				closeModal();
			}
		}
	}, [planGoalSubmitData])

	// console.log("inputData @ : ", inputData, selectedCourse, courseLength, courseIndex);

	const handleUndo = ()=>{
		getSequnceSort(selectedCourse?.goal?.keyResults)?.map((goalObj, index)=>{
			if(checkBoxIds?.includes(goalObj?.id)){
				goalObj.isCompleted = !goalObj.isCompleted;
			}
			setCheckBoxIds([]);
		})
	}
	// console.log("PlanGoals : ",courseLength, selectedCourse, planCourseGoalData, dashBoardPlanData,planGoalSubmitData,isCodeRender);
	return (
		<div className="smallpopup calendarSchedule RootContent">
			<div className="modal d-flex" id="schoolactivity5" role="dialog">
				<div className="">
					<div className="modal-content my_popup halfscreen_popup">
						<div className="modal-header goalplanhdr">
							<h2 className="flexone w-100">
								<span>
									📝 Plan Goals
									<span className="infoicons">
										<img
											src={image.newinfoicon}
											alt=""
											className="newinfoicons ml-3"
										/>
										<div className="mytoottiptxt p-3">
											<p className="p1 mb-1">Goals and Key Results (OKRs)</p>
											<p className="p2">
									        	Your <i>goal</i> is the <strong>outcome</strong>  your child is working toward — the <i> what</i>.
												</p>
												<p className="p2">
												 Each goal is supported by <i>5 key results</i>  — the <strong>actions</strong> that help achieve that goal — the <i>how</i>.
									    	</p>
											<ul>
												<li><strong>KR1–KR3</strong>: Tracked automatically based on course progress (not editable).</li>
												<li><strong>KR4–KR5</strong>: Editable and course-specific. You can adjust them to fit your child’s needs.</li>
											</ul>
											<p className="p2">OKRs help your child stay focused, motivated, and on track to build real-life skills through each course.</p>
										</div>
									</span>
								</span>
								<button
									className="closebtn"
									data-dismiss="modal"
									onClick={() => closeModal()}
								>
									<i class="fa-regular fa-xmark"></i>
								</button>
							</h2>
						</div>

						<div class="modal-body paymentinfo p-0">


							<div class="flexone w-100">
								
								<div class="select_Profile_input w-100 calendar_schedule_label mb-0 flexone">
									{courseLength > 1 && (
										<span
											class="dropdwnicon pointer flexfive"
											href="#showDimensionSkill0"
											aria-expanded="true"
											onClick={() => handleSelectedCourse(courseIndex - 1)}
										>
										<i class="fa-regular fa-chevron-left"></i>				
										</span>
									)}
									<p class="text-center w-100">
										Course {courseLength > 1 && courseIndex + 1}: {selectedCourse?.courseName}
									</p>
									{courseIndex+1 <  courseLength && (
										<span
										class="dropdwnicon pointer flexfive"
										href="#showDimensionSkill0"
										aria-expanded="true"  
										onClick={() => showAlertPopUp()}
									>
                    					{" "}                    
										<i class="fa-regular fa-chevron-right"></i>
									</span>
									)}
								</div>
							</div>




							<div class="flexone w-100 mt-1 gap">
								<div class="select_Profile_input w-10 calendar_schedule_label mt-1 mb-0 flexfive">
									<p class="text-center">
										Goals
										<span className="infoicons">
											<img
												src={image.newinfoicon}
												alt=""
												className="newinfoicons ml-2"
											/>
											<div className="mytoottiptxt p-3">
												<p className="p1 mb-1">Custom KRs</p>
												<p className="p2">
													The goal is the outcome your child is aiming to achieve — it defines what they’re working toward in this course.
												</p>
											</div>
										</span>
									</p>
								</div>
								<div class="select_Profile_input w-90 calendar_schedule_checkbox mt-1 mb-0 flexone">
									<div class="d-flex pl-2 flexfive">
										<div class="Ansoptions checkboxtyped">
											<label className={`selAnslabel m-0  ${selectedCourse?.isDefinedGoal ? "":"pl-0"} `}>
												<p className={`text-center  `}>
													{selectedCourse?.goal?.name}
												</p>
												{selectedCourse?.isDefinedGoal && (
													<>
													    <input 
															type="checkbox" 
															name={"knowledgecheck" + courseIndex}
															checked={selectedCourse?.goal?.keyResults?.every((item)=>item?.isCompleted)}
														    disabled={true} />
														<span className="checkmark"></span>
													</>
												)}

											</label>
										</div>
									</div>
								</div>
							</div>
							{getSequnceSort(selectedCourse?.goal?.keyResults)?.map((goalObj, index) => (

								<>
									{inputData?.includes(index+1) ? (
										<div class="flexone w-100 mt-1 gap">
											<div class="select_Profile_input w-10 calendar_schedule_label mt-1 mb-0 flexfive">
												<p class="text-center">
													KR 4
													<span className="infoicons">
														<img
															src={image.newinfoicon}
															alt=""
															className="newinfoicons ml-2"
														/>
														<div className="mytoottiptxt p-3">
															<p className="p1 mb-1">Custom KRs</p>
															<p className="p2">
																A key result (KR) is a specific action or milestone that shows how your child is making progress toward their goal.
															</p>
														</div>
													</span>
												</p>
											</div>
											<div class="select_Profile_input w-90 calendar_schedule_checkbox mt-1 mb-0 flexone">
												<div class="d-flex flexone w-100">
													<div class="input-group">
														<div class="form-group flextwo" >
															<input
																key={index}
																type="text"
																class="form-control w-75 p-0"
																value={goalObj?.keyName}
																onChange={(e) => handleInputChange(goalObj, e.target.value)}
															/>
															<span className="textrelatedicons pointer ml-auto" onClick={() => handleInput(index+1)}>
																<span className="savedicon" >
																	<i class="fa-solid fa-check"></i>
																</span>
																<span className="cleartxticon">
																	<i class="fa-solid fa-xmark-large"></i>
																</span>
															</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									) : (
										<div class="flexone w-100 mt-1 gap" key={index}>
											<div class="select_Profile_input w-10 calendar_schedule_label mt-1 mb-0 flexfive">
												<p class="text-center">
													KR {index + 1}
													<span className="infoicons">
														<img
															src={image.newinfoicon}
															alt=""
															className="newinfoicons ml-2"
														/>
														<div className="mytoottiptxt p-3">
															<p className="p1 mb-1">{index < 3 ? 'Platform' : 'Custom'} KRs</p>
															<p className="p2">
																A key result (KR) is a specific action or milestone that shows how your child is making progress toward their goal.
															</p>
														</div>
													</span>
												</p>
											</div>
											<div class="select_Profile_input w-90 calendar_schedule_checkbox mt-1 mb-0 flexone">
												<div class="d-flex pl-2 flexone w-100">
													<div class="Ansoptions checkboxtyped">
														<label class={`selAnslabel m-0 ${selectedCourse?.isDefinedGoal ? "":"pl-0"}`}>
															<p class="text-center ">
																{goalObj?.keyName}
															</p>
															{selectedCourse?.isDefinedGoal && (
																<>
																	<input type="checkbox" name={"knowledgecheck" + courseIndex} onChange={() => handleCheckBox(goalObj)}
																		checked={goalObj?.isCompleted} disabled={index < 3}
																	/>

																	<span class="checkmark"></span>
																</>
															)}

														</label>

													</div>
													{index > 2 && (
														<span className="textrelatedicons pointer ml-auto mt-1" onClick={() => handleInput(index+1)}>
															<span >
																<i class="fa-solid fa-pen mr-1"></i>
															</span>
														</span>
													)}

												</div>
											</div>
										</div>
									)}
								</>

							))}

							{/* <div class="flexone w-100 mt-1 gap">
                <div class="select_Profile_input w-10 calendar_schedule_label mt-1 mb-0">
                  <p class="text-center">
                    KR 2
                    <span className="infoicons">
                      <img
                        src={image.newinfoicon}
                        alt=""
                        className="newinfoicons ml-2"
                      />
                      <div className="mytoottiptxt p-3">
                        <p className="p1 mb-1">Custom KRs</p>
                        <p className="p2">
                          You can edit and customize KR 4 and 5, Hover over them
                          to edit them for yourselves.
                        </p>
                      </div>
                    </span>
                  </p>
                </div>
                <div class="select_Profile_input w-90 calendar_schedule_checkbox mt-1 mb-0">
                  <div class="d-flex pl-2">
                    <div class="Ansoptions checkboxtyped">
                      <label class="selAnslabel m-0">
                        <p class="text-center ">
                          Help Alex Jr complete all lessons across 4 modules by
                          4th May 2025
                        </p>
                        <input type="checkbox" name="knowledgecheck" />
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flexone w-100 mt-1 gap">
                <div class="select_Profile_input w-10 calendar_schedule_label mt-1 mb-0">
                  <p class="text-center">
                    KR 3
                    <span className="infoicons">
                      <img
                        src={image.newinfoicon}
                        alt=""
                        className="newinfoicons ml-2"
                      />
                      <div className="mytoottiptxt p-3">
                        <p className="p1 mb-1">Custom KRs</p>
                        <p className="p2">
                          You can edit and customize KR 4 and 5, Hover over them
                          to edit them for yourselves.
                        </p>
                      </div>
                    </span>
                  </p>
                </div>
                <div class="select_Profile_input w-90 calendar_schedule_checkbox mt-1 mb-0">
                  <div class="d-flex pl-2">
                    <div class="Ansoptions checkboxtyped">
                      <label class="selAnslabel m-0">
                        <p class="text-center">
                          Help Alex Jr complete all lessons across 4 modules by
                          4th May 2025
                        </p>
                        <input type="checkbox" name="knowledgecheck" />
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div> */}
							{/* <div class="flexone w-100 mt-1 gap">
                <div class="select_Profile_input w-10 calendar_schedule_label mt-1 mb-0">
                  <p class="text-center">
                    KR 4
                    <span className="infoicons">
                      <img
                        src={image.newinfoicon}
                        alt=""
                        className="newinfoicons ml-2"
                      />
                      <div className="mytoottiptxt p-3">
                        <p className="p1 mb-1">Custom KRs</p>
                        <p className="p2">
                          You can edit and customize KR 4 and 5, Hover over them
                          to edit them for yourselves.
                        </p>
                      </div>
                    </span>
                  </p>
                </div>
                <div class="select_Profile_input w-90 calendar_schedule_checkbox mt-1 mb-0">
                  <div class="d-flex ">
                    <div class="input-group">
                      <div class="form-group flextwo">
                        <input
                          type="text"
                          class="form-control w-75 p-0"
                          placeholder="You can add Your Kra"
                        />
                        <span className="textrelatedicons">
                          <span>
                            <i class="fa-solid fa-pen mr-1"></i>
                          </span>
                          <span className="savedicon">
                            <i class="fa-solid fa-check"></i>
                          </span>
                          <span className="cleartxticon">
                            <i class="fa-solid fa-xmark-large"></i>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flexone w-100 mt-1 gap">
                <div class="select_Profile_input w-10 calendar_schedule_label mt-1 mb-0">
                  <p class="text-center">
                    KR 5
                    <span className="infoicons">
                      <img
                        src={image.newinfoicon}
                        alt=""
                        className="newinfoicons ml-2"
                      />
                      <div className="mytoottiptxt p-3">
                        <p className="p1 mb-1">Custom KRs</p>
                        <p className="p2">
                          You can edit and customize KR 4 and 5, Hover over them
                          to edit them for yourselves.
                        </p>
                      </div>
                    </span>
                  </p>
                </div>
                <div class="select_Profile_input w-90 calendar_schedule_checkbox mt-1 mb-0">
                  <div class="d-flex ">
                    <div class="input-group">
                      <div class="form-group flextwo">
                        <input
                          type="text"
                          class="form-control w-75 p-0"
                          placeholder="You can add Your Kra"
                        />
                        <span className="textrelatedicons">
                          <span className="savedicon">
                            <i class="fa-solid fa-check"></i>
                          </span>
                          <span className="cleartxticon">
                            <i class="fa-solid fa-xmark-large"></i>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
							<div class={`modal-footer mt-4`}>
								<div class="text-right">
									{courseIndex+1 <  courseLength && (
										<span 
											// className={`${courseIndex + 1 === courseLength && "disablesd_button"}`}
										>
											<a href="javacript:void(0) " class={`mr-3 false`} onClick={() => handleSelectedCourse(courseIndex + 1)}>
												Skip
											</a>
										</span>
									)}
									<button type="button " class={`mybutton secondtpebtn ${selectedCourse?.goal?.keyResults?.every((item)=>item?.keyName) ? "" :"disabledevent"}`}
										onClick={() => showAlertPopUp()}
									>
										{courseIndex + 1 === courseLength ? "Save" : "Save And Go To Next"}

									</button>
								</div>
							</div>
						</div>

						{/* <div className="modal-footer">
                        <div className="text-right">
                              <button
                                type="button"
                                className="mybutton"
                              >
                                 Continue
                              </button>
                         </div>
                      </div> */}
					</div>
				</div>
			</div>
			{isAlert && (
				<GoalSubmitPopUp
					closePopUp={closePopUp}
					courseIndex={courseIndex}
					handleSelectedCourse={handleSelectedCourse}
					handleUndo={handleUndo}
				/>
			)}
		</div>
	);
};
export default PlanGoals;
